// user.actions.js
import axios from "../helpers/axios";
import { setUser, setPageNumberUsers } from "../reducers/user.reducer";
import { userConstants } from './constants';

const getErrorMessage = (error, fallback = "Ошибка запроса") => {
    return error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        fallback;
};

export const adminCreateUser = (payload) => {
    return async (dispatch) => {
        try {
            dispatch({ type: userConstants.CREATE_USER_REQUEST });
            const res = await axios.post("/admin/users", payload);

            if (res.status === 201) {
                dispatch({ type: userConstants.CREATE_USER_SUCCESS, payload: res.data });
                dispatch(getUsers());

                return {
                    ok: true,
                    ...res.data,
                };
            }

            const message = res.data?.message || "Ошибка создания";
            dispatch({ type: userConstants.CREATE_USER_FAILURE, payload: { message } });

            return {
                ok: false,
                message,
            };
        } catch (error) {
            const message = getErrorMessage(error, "Ошибка создания");

            dispatch({
                type: userConstants.CREATE_USER_FAILURE,
                payload: { message },
            });

            return {
                ok: false,
                message,
                verificationRequired: !!error?.response?.data?.verificationRequired,
                userId: error?.response?.data?.userId || null,
            };
        }
    };
};

export const adminConfirmCreatedUserEmail = ({ userId, code }) => {
    return async (dispatch) => {
        try {
            const res = await axios.post(`/admin/users/${userId}/verification/confirm`, {
                code: String(code || "").trim(),
            });

            if (res.status === 200) {
                dispatch(getUsers());

                return {
                    ok: true,
                    ...res.data,
                };
            }

            return {
                ok: false,
                message: res.data?.message || "Ошибка подтверждения email",
            };
        } catch (error) {
            return {
                ok: false,
                message: getErrorMessage(error, "Ошибка подтверждения email"),
                attemptsLeft: error?.response?.data?.attemptsLeft,
            };
        }
    };
};

export const adminResendCreatedUserEmail = (userId) => {
    return async () => {
        try {
            const res = await axios.post(`/admin/users/${userId}/verification/resend`);

            return {
                ok: res.status === 200,
                ...res.data,
            };
        } catch (error) {
            return {
                ok: false,
                message: getErrorMessage(error, "Ошибка повторной отправки кода"),
                secondsLeft: error?.response?.data?.secondsLeft || 0,
            };
        }
    };
};


export const adminRequestUserEmailVerification = (userId) => {
    return async (dispatch) => {
        try {
            const res = await axios.post(`/admin/users/${userId}/email-verification/request`);

            if (res.data?.user) {
                dispatch({
                    type: userConstants.GET_USER_BY_ID_SUCCESS,
                    payload: { userDetails: res.data.user },
                });
                dispatch(getUsers());
            }

            return {
                ok: res.status === 200,
                ...res.data,
            };
        } catch (error) {
            return {
                ok: false,
                message: getErrorMessage(error, "Не удалось отправить код подтверждения"),
                secondsLeft: error?.response?.data?.secondsLeft || 0,
            };
        }
    };
};

export const adminConfirmUserEmailVerification = (userId, code) => {
    return async (dispatch) => {
        try {
            const res = await axios.post(`/admin/users/${userId}/email-verification/confirm`, {
                code: String(code || "").trim(),
            });

            if (res.status === 200) {
                if (res.data?.user) {
                    dispatch({
                        type: userConstants.GET_USER_BY_ID_SUCCESS,
                        payload: { userDetails: res.data.user },
                    });
                }

                dispatch(getUsers());

                return {
                    ok: true,
                    ...res.data,
                };
            }

            return {
                ok: false,
                message: res.data?.message || "Не удалось подтвердить email",
            };
        } catch (error) {
            return {
                ok: false,
                message: getErrorMessage(error, "Не удалось подтвердить email"),
                attemptsLeft: error?.response?.data?.attemptsLeft,
            };
        }
    };
};

export const updateUserRole = ({ id, role }) => {
    return async (dispatch) => {
        dispatch({ type: userConstants.UPDATE_USER_ROLE_REQUEST });
        try {
            const res = await axios.put(`/admin/updateUserRole/${id}/${role}`);
            if (res.status === 200) {
                dispatch({ type: userConstants.UPDATE_USER_ROLE_SUCCESS, payload: res.data });
                dispatch(getUsers());
                return { ok: true, ...res.data };
            }
            const message = res.data?.message || "Ошибка смены роли";
            dispatch({ type: userConstants.UPDATE_USER_ROLE_FAILURE, payload: { message } });
            return { ok: false, message };
        } catch (error) {
            const message = getErrorMessage(error, "Ошибка смены роли");
            dispatch({ type: userConstants.UPDATE_USER_ROLE_FAILURE, payload: { message } });
            return { ok: false, message };
        }
    };
};

export const adminUpdateUserProfile = (userId, fields = {}) => {
    return async (dispatch) => {
        try {
            const res = await axios.patch(`/admin/users/${userId}`, { fields });
            if (res.status === 200) {
                if (res.data?.user) dispatch({ type: userConstants.GET_USER_BY_ID_SUCCESS, payload: { userDetails: res.data.user } });
                dispatch(getUsers());
                return { ok: true, ...res.data };
            }
            return { ok: false, message: res.data?.message || "Ошибка обновления пользователя" };
        } catch (error) {
            return { ok: false, message: getErrorMessage(error, "Ошибка обновления пользователя") };
        }
    };
};

export const adminRequestUserEmailChange = (userId, email) => {
    return async () => {
        try {
            const res = await axios.post(`/admin/users/${userId}/email-change/request`, {
                email: String(email || "").trim(),
            });

            return {
                ok: res.status === 200,
                ...res.data,
            };
        } catch (error) {
            return {
                ok: false,
                message: getErrorMessage(error, "Не удалось отправить код на новый email"),
                secondsLeft: error?.response?.data?.secondsLeft || 0,
            };
        }
    };
};

export const adminConfirmUserEmailChange = (userId, code) => {
    return async (dispatch) => {
        try {
            const res = await axios.post(`/admin/users/${userId}/email-change/confirm`, {
                code: String(code || "").trim(),
            });

            if (res.status === 200) {
                if (res.data?.user) {
                    dispatch({
                        type: userConstants.GET_USER_BY_ID_SUCCESS,
                        payload: { userDetails: res.data.user },
                    });
                }

                dispatch(getUsers());

                return {
                    ok: true,
                    ...res.data,
                };
            }

            return {
                ok: false,
                message: res.data?.message || "Не удалось подтвердить новый email",
            };
        } catch (error) {
            return {
                ok: false,
                message: getErrorMessage(error, "Не удалось подтвердить новый email"),
                attemptsLeft: error?.response?.data?.attemptsLeft,
            };
        }
    };
};

export const adminResetUserPassword = (userId) => {
    return async () => {
        try {
            const res = await axios.post(`/admin/users/${userId}/password/reset`);

            return {
                ok: res.status === 200,
                ...res.data,
            };
        } catch (error) {
            return {
                ok: false,
                message: getErrorMessage(error, "Не удалось отправить новый пароль"),
            };
        }
    };
};

export const adminToggleSubscriptionCompletion = (subscriptionId, userId) => {
    return async (dispatch) => {
        try {
            const res = await axios.put(`/admin/subscriptions/${subscriptionId}/${userId}`);
            dispatch({ type: userConstants.UPDATE_TOGGLE_SUBSCRIPTION_BY_ID_REQUEST });
            if (res.status === 200) {
                dispatch({
                    type: userConstants.UPDATE_TOGGLE_SUBSCRIPTION_BY_ID_SUCCESS,
                    payload: res.data,
                });
            } else {
                dispatch({
                    type: userConstants.UPDATE_TOGGLE_SUBSCRIPTION_BY_ID_FAILURE,
                    payload: res.data,
                });
            }
        } catch (error) {
            console.log(error);
        }
    };
};

export const addStandardSubscriptions = (userId) => {
    return async (dispatch) => {
        try {
            dispatch({ type: userConstants.ADD_STANDARD_SUBSCRIPTIONS_REQUEST });
            const res = await axios.post(`/admin/addStandardSubscriptions/${userId}`);
            if (res.status === 201) {
                dispatch({
                    type: userConstants.ADD_STANDARD_SUBSCRIPTIONS_SUCCESS,
                    payload: res.data,
                });
                dispatch(getUsers())
            } else {
                dispatch({
                    type: userConstants.ADD_STANDARD_SUBSCRIPTIONS_FAILURE,
                    payload: res.data,
                });
            }
        } catch (error) {
            const { message } = error.response.data;
            dispatch({
                type: userConstants.ADD_STANDARD_SUBSCRIPTIONS_FAILURE,
                payload: { message },
            });
        }
    };
};

export const updateUserPassword = (payload) => {
    return async (dispatch) => {
        try {
            dispatch({ type: userConstants.UPDATE_USER_PASSWORD_REQUEST });
            const res = await axios.post("/admin/updateUserPassword", payload);
            if (res.status === 201) {
                const { message, user } = res.data;
                dispatch({
                    type: userConstants.UPDATE_USER_PASSWORD_SUCCESS,
                    payload: { message, user },
                });
                dispatch(getUsers())
            } else {
                const { message } = res.data;
                dispatch({
                    type: userConstants.UPDATE_USER_PASSWORD_FAILURE,
                    payload: { error: message },
                });
            }
        } catch (error) {
            const { message } = error.response.data;
            dispatch({
                type: userConstants.UPDATE_USER_PASSWORD_FAILURE,
                payload: { message },
            });
        }
    };
};

export const updateUser = (payload) => {
    return async (dispatch) => {
        try {
            dispatch({ type: userConstants.UPDATE_USER_REQUEST });
            const res = await axios.post("/admin/updateUser", payload);
            if (res.status === 201) {
                const { message, user } = res.data;
                dispatch({
                    type: userConstants.UPDATE_USER_SUCCESS,
                    payload: { message, user },
                });
                dispatch(getUsers())
            } else {
                const { message } = res.data;
                dispatch({
                    type: userConstants.UPDATE_USER_FAILURE,
                    payload: { error: message },
                });
            }
        } catch (error) {
            const { message } = error.response.data;
            dispatch({
                type: userConstants.UPDATE_USER_FAILURE,
                payload: { message },
            });
        }
    };
};

export const signup = (user) => {
    return async (dispatch) => {
        try {
            dispatch({ type: userConstants.USER_REGISTER_REQUEST });
            const res = await axios.post("/admin/signup", { ...user });
            if (res.status === 201) {
                const { message } = res.data;
                dispatch({
                    type: userConstants.USER_REGISTER_SUCCESS,
                    payload: { message },
                });
            } else {
                const { message } = res.data;
                dispatch({
                    type: userConstants.USER_REGISTER_FAILURE,
                    payload: { error: message },
                });
            }
        } catch (error) {
            const { message } = error.response.data;
            dispatch({
                type: userConstants.USER_REGISTER_FAILURE,
                payload: { message },
            });
        }
    };
};

export const getUserById = (userId) => {
    return async dispatch => {
        dispatch({ type: userConstants.GET_USER_BY_ID_REQUEST });
        let res
        try {
            res = await axios.get(`/admin/getUserById/${userId}`);
            dispatch({
                type: userConstants.GET_USER_BY_ID_SUCCESS,
                payload: { userDetails: res.data.user }
            });

        } catch (error) {
            console.log(error);
            dispatch({
                type: userConstants.GET_USER_BY_ID_FAILURE
            });
        }
    }
}

export const getUsers = (search, sort, customPage, customPageSize) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: userConstants.GET_ALL_USERS_REQUEST });

            const { user } = getState();

            const page = typeof customPage === "number" ? customPage : (user.pageNumber ?? 0);
            const pageSize = typeof customPageSize === "number" ? customPageSize : (user.pageSize ?? 12);
            const activeSort = typeof sort === "string" ? sort : (user.sort || "updatedAtMinus");
            const activeSearch = typeof search === "string" ? search : (user.search || "");

            const params = new URLSearchParams();
            params.append("page", page);
            params.append("pageSize", pageSize);
            if (activeSort) params.append("sort", activeSort);
            if (activeSearch) params.append("search", activeSearch);

            const res = await axios.get(`/admin/getUsers?${params.toString()}`);

            if (res.status === 200) {
                dispatch({ type: userConstants.GET_ALL_USERS_SUCCESS, payload: res.data });
            } else {
                dispatch({ type: userConstants.GET_ALL_USERS_FAILURE });
            }
        } catch (error) {
            console.log(error);
            dispatch({ type: userConstants.GET_ALL_USERS_FAILURE });
        }
    };
};

export const searchUser = (search) => {
    return async (dispatch) => {
        return dispatch(getUsers(search, undefined, 0));
    };
};

export const updateSubscribeEmailAddress = (id) => async (dispatch) => {
    try {
        const data = await axios.get(`/admin/subscribeEmailAddress/${id}`)
        dispatch({
            type: userConstants.UPDATE_SUBSCRIBE_EMAIL_ADDRESS_BY_ID, payload: data
        })
        dispatch(setUser(data))
    } catch (error) {
        console.log(error);
    }
}

export const getUserCart = (userId) => {
    return async (dispatch) => {
        try {
            dispatch({ type: userConstants.GET_USER_CART_REQUEST });
            const res = await axios.get(`/admin/getUserCartProduct/${userId}`);
            const data = res?.data;
            if (res && res.status === 200 && data) {
                dispatch({ type: userConstants.GET_USER_CART_SUCCESS, payload: data });
            } else {
                dispatch({ type: userConstants.GET_USER_CART_FAILURE });
            }
        } catch (error) {
            console.log(error);
            dispatch({
                type: userConstants.GET_USER_CART_FAILURE,
                payload: error.response?.data,
            });
        }
    };
};

export const getUserDesires = (userId) => {
    return async (dispatch) => {
        try {
            dispatch({ type: userConstants.GET_USER_DESIRES_REQUEST });
            const res = await axios.get(`/admin/getUserDesiresProduct/${userId}`);
            const data = res?.data;
            if (res && res.status === 200 && data) {
                dispatch({
                    type: userConstants.GET_USER_DESIRES_SUCCESS,
                    payload: data
                });
            } else {
                dispatch({ type: userConstants.GET_USER_DESIRES_FAILURE });
            }
        } catch (error) {
            console.log(error);
            dispatch({
                type: userConstants.GET_USER_DESIRES_FAILURE,
                payload: error.response?.data
            });
        }
    };
};

export const getUserProductViews = (userId) => {
    return async (dispatch) => {
        try {
            dispatch({ type: userConstants.GET_USER_PRODUCT_VIEWS_REQUEST })
            const res = await axios.get(`/admin/getUserProductViews/${userId}`)
            const data = res?.data;
            if (res && res.status === 200 && data) {
                dispatch({
                    type: userConstants.GET_USER_PRODUCT_VIEWS_SUCCESS,
                    payload: res.data
                })
            } else {
                dispatch({ type: userConstants.GET_USER_PRODUCT_VIEWS_FAILURE })
            }
        } catch (error) {
            console.log(error)
            dispatch({
                type: userConstants.GET_USER_PRODUCT_VIEWS_FAILURE,
                payload: error.response?.data
            })
        }

    }
}
